import type { ReactNode } from 'react';
import clsx from 'clsx';

type Tone = 'error' | 'success' | 'info';

const tones: Record<Tone, string> = {
  error: 'border-error/40 text-error',
  success: 'border-success/40 text-success',
  info: 'border-line text-content-secondary',
};

export function Alert({ tone = 'info', children }: { tone?: Tone; children: ReactNode }) {
  return (
    <div className={clsx('rounded-control border bg-surface-secondary px-4 py-3 text-body', tones[tone])}>
      {children}
    </div>
  );
}
